function Vector3D(xx, yy, zz) {
	this.x = xx;
	this.y = yy;
	this.z = zz;
	this.w = 0;
}

Vector3D.prototype = {

		projectTo2D: function() {
			var rx = this.x / this.w;
			var ry = this.y / this.w;
//			var rx = this.x / this.z;
//			var ry = this.y / this.z;
			
			return {'x': rx, 'y':ry};
		},
	
		dot: function(vec) {
			return this.x * vec.x + this.y * vec.y + this.z * vec.z;
		},
		
		cross: function(vec) {			
			var cx = this.y * vec.z - this.z * vec.y;
			var cy = this.z * vec.x - this.x * vec.z;
			var cz = this.x * vec.y - this.y * vec.x;
			this.x = cx;
			this.y = cy;
			this.z = cz;
			return this;
		},
	
		normalize: function() {
			var l = this.length();
			
			this.x = this.x / l;
			this.y = this.y / l;
			this.z = this.z / l;
			return this;
		},
		
		lengthSquare: function() {
			return this.x * this.x + this.y * this.y + this.z * this.z;
		},
		
		length: function() {
			return Math.sqrt(this.lengthSquare());
		},
	
		transformByMatrix: function(mtx) {
			/*
			var nx = this.x * mtx.entities[0] + this.y * mtx.entities[1] + this.z * mtx.entities[2] + this.w * mtx.entities[3];
			var ny = this.x * mtx.entities[4] + this.y * mtx.entities[5] + this.z * mtx.entities[6] + this.w * mtx.entities[7];
			var nz = this.x * mtx.entities[8] + this.y * mtx.entities[9] + this.z * mtx.entities[10] + this.w * mtx.entities[11];
			var nw = this.x * mtx.entities[12] + this.y * mtx.entities[13] + this.z * mtx.entities[14] + this.w * mtx.entities[15];
			*/
			var nx = this.x * mtx.entities[0] + this.y * mtx.entities[4] + this.z * mtx.entities[8] + this.w * mtx.entities[12];
			var ny = this.x * mtx.entities[1] + this.y * mtx.entities[5] + this.z * mtx.entities[9] + this.w * mtx.entities[13];
			var nz = this.x * mtx.entities[2] + this.y * mtx.entities[6] + this.z * mtx.entities[10] + this.w * mtx.entities[14];
			var nw = this.x * mtx.entities[3] + this.y * mtx.entities[7] + this.z * mtx.entities[11] + this.w * mtx.entities[15];
			
			this.x = nx;
			this.y = ny;
			this.z = nz;
			this.w = nw;
			return this;
		},

		distanceFrom: function(line) {
			var d = (line.x * this.x + line.y * this.y + line.z * this.z)
			return d;
		}
}